import React from 'react';
import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CommonButton from '@src/new-components/Button';
import Tooltip from '@src/components/Tooltip';
import { COLOR } from '@src/styles/color';
import GenerateScriptIcon from '@src/assets/icons/generating-script.svg';

const AIGenerateButton = ({ loading = false, disabled = false, onClick }) => {
  const { t } = useTranslation();
  const startIcon = loading ? (
    <CircularProgress
      className="ai-icon loading-icon"
      size={20}
      thickness={3.6}
    />
  ) : (
    <img src={GenerateScriptIcon} alt="Generate Script" className="ai-icon" />
  );

  return (
    <Tooltip title={t('aiPresentationScriptDescription')} placement="top" arrow>
      <span style={{ display: 'inline-flex', flexShrink: 0 }}>
        <CommonButton
          variant="outlined"
          type="button"
          onClick={onClick}
          disabled={disabled || loading}
          startIcon={startIcon}
          customStyle={{
            height: '32px',
            padding: '4px 12px 4px 8px',
            border: `1px solid ${COLOR.blue700}`,
            borderRadius: '8px',
            backgroundColor: COLOR.white,
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '20px',
            letterSpacing: '-0.4px',
            color: COLOR.blue600,
            cursor: 'pointer',
            flexShrink: 0,
            minWidth: 'fit-content',
            whiteSpace: 'nowrap',
            textTransform: 'none',
            gap: '4px',
            '&:hover': {
              border: `1px solid ${COLOR.blue700}`,
            },
            '& .MuiButton-startIcon': {
              margin: 0,
            },
            '& .ai-icon': {
              display: 'block',
              flexShrink: 0,
              height: '20px',
              width: '20px',
            },
            '& .loading-icon': {
              color: COLOR.blue600,
            },
            '&&.Mui-disabled': {
              opacity: 0.3,
              border: `1px solid ${COLOR.blue700}`,
              backgroundColor: COLOR.white,
              color: COLOR.blue600,
              WebkitTextFillColor: COLOR.blue600,
            },
          }}
          bgrDisabled={COLOR.white}
        >
          {t('aiPresentationScript')}
        </CommonButton>
      </span>
    </Tooltip>
  );
};

export default AIGenerateButton;
